import React from "react";
import PopoverDropdown from "../../../../elements/PopoverDropdown";
import { SketchPicker } from "react-color";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { rgba } from "../../../../../helpers";
import { setThemeValue } from "../../../../../redux/slice/themeSlice";

const PreviewTool = ({ element }) => {
  const dispatch = useDispatch();
  const { theme, selectedElement } = useSelector(
    (state) => state?.themeProvider
  );
  return (
    <div className="background-color">
      <div className="text-[14px] font-medium text-slate-600 mb-1 font-CanelaDeck">
        Background color
      </div>
      <PopoverDropdown
        buttonLabel={
          <div className="flex items-center space-x-2">
            {theme?.[element]?.backgroundColor && (
              <span
                className="w-6 h-6 flex rounded"
                style={{
                  backgroundColor: rgba(theme?.[element]?.backgroundColor),
                }}
              ></span>
            )}
            <span>Select colour</span>
          </div>
        }
        buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
        contentClass="border-0 p-0 !min-w-fit bg-transparent"
      >
        <SketchPicker
          className="!shadow-none !border-0"
          color={theme?.[element]?.backgroundColor}
          onChange={(e) => {
            dispatch(
              setThemeValue({
                [element]: { ...theme?.[element], backgroundColor: e.rgb },
              })
            );
          }}
        />
      </PopoverDropdown>
    </div>
  );
};

export default PreviewTool;
